export default {
  loginRegisterH: {
    back: "Back to Home",
    industry: "Industry Dashboard", 
    business: "Enterprise Dashboard",
    welcome: "Welcome",
    noAccount: "No account yet?",
    toRegister: "Register Now",
    yesAccount: "Already have an account?",
    toLogin: "Login Now"
  }
}